import React from 'react';
import { commonStyles } from '../styles/commonStyles';

interface TextFieldProps {
  /** Translated label text. */
  label: string;
  value: string;
  /** Receives the raw input value. */
  onChange: (value: string) => void;
  id?: string;
  required?: boolean;
  placeholder?: string;
  /** Already-translated error message (or null/empty for no error). */
  error?: string | null;
  type?: string;
  inputMode?: React.InputHTMLAttributes<HTMLInputElement>['inputMode'];
  maxLength?: number;
  min?: string | number;
  step?: string | number;
  onBlur?: () => void;
  /** Extra style merged onto the field container (e.g. flex sizing inside a row). */
  containerStyle?: React.CSSProperties;
}

// Shared labelled text input — the input counterpart of SelectField. Label (+ required asterisk), a
// styled input with the canonical commonStyles look (+ error state), and an error line. Replaces the
// hand-rolled label/input/error trio repeated across the product screens.
export const TextField: React.FC<TextFieldProps> = ({
  label, value, onChange, id, required = false, placeholder, error = null,
  type = 'text', inputMode, maxLength, min, step, onBlur, containerStyle,
}) => (
  <div style={{ ...commonStyles.fieldContainer, ...containerStyle }}>
    <label style={commonStyles.formLabel} htmlFor={id}>
      {label}{required && <span style={commonStyles.required}> *</span>}
    </label>
    <input
      id={id}
      type={type}
      value={value}
      inputMode={inputMode}
      maxLength={maxLength}
      min={min}
      step={step}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      data-error={error ? 'true' : undefined}
      style={{ ...commonStyles.fieldInput, ...(error ? commonStyles.fieldInputError : {}) }}
    />
    {error && <p style={commonStyles.fieldErrorMessage}>{error}</p>}
  </div>
);

export default TextField;
